module.exports = __webpack_public_path__ + "static/media/hoist.4d81ed75.png";